<div class="flex d-flex-justify-between pt-6 px-10">
  <h3 class="product-heading-bold">Rate cards</h3>
  <div class="flex gap-1 items-center">
    <scope-ui-input
      class="mr-2"
      [icon]="'search'"
      [cancelIcon]="'cancel'"
      [inputLabel]="'Search'"
      [inputClass]="'search-field'"
      (onCancel)="searchText = ''; filterRateCards()"
      (onEnter)="searchText = $event; filterRateCards()" />

    <!-- View mode toggle -->
    <div class="flex gap-0 mr-2 view-toggle-buttons">
      <button
        class="view-toggle-button"
        [class.active]="viewMode === RateCardViewMode.TILES"
        (click)="onToggleViewMode(RateCardViewMode.TILES)"
        matTooltip="Tiles view">
        <mat-icon class="material-symbols-rounded">grid_view</mat-icon>
      </button>
      <button
        class="view-toggle-button"
        [class.active]="viewMode === RateCardViewMode.LIST"
        (click)="onToggleViewMode(RateCardViewMode.LIST)"
        matTooltip="List view">
        <mat-icon class="material-symbols-rounded">view_list</mat-icon>
      </button>
    </div>

    <button
      [has-privilege]="'RATECARD__CREATE'"
      (click)="showAddRateCardDialog()"
      mat-flat-button>
      <mat-icon class="material-symbols-rounded">add</mat-icon> Add rate card
    </button>
    <button
      class="scope-actions-button"
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="optionsMenu">
      <mat-icon class="material-symbols-rounded">more_vert</mat-icon>
    </button>
    <mat-menu
      #optionsMenu="matMenu"
      backdropClass="scope-options-menu">
      <ng-container *ngFor="let option of menuOptions">
        <button
          (click)="option.click()"
          *ngIf="option.isVisible ? option.isVisible() : true"
          mat-menu-item
          class="scope-option">
          <mat-icon class="material-symbols-rounded orange">{{ option.icon }}</mat-icon>
          <span>{{ option.name }}</span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</div>

<!-- Tiles View -->
<ng-container *ngIf="viewMode === RateCardViewMode.TILES">
  <div
    class="card-wrapper p-10"
    [hidden]="!loadingRateCards">
    <div
      class="card-skeleton"
      *ngFor="let x of [].constructor(16)"></div>
  </div>
  <div class="card-wrapper p-10">
    <scope-ui-card-master
      *ngFor="let rateCard of filteredRateCards | orderBy: 'name' : 'asc' : false; trackBy: trackById"
      (click)="selectRateCard(rateCard.rateCardIdentity.id)"
      [actionButtons]="[
        {
          icon: rateCard.rateCardIdentity.defaultCard ? 'check_circle' : 'archive',
          name: rateCard.rateCardIdentity.defaultCard ? 'Default' : 'Archive',
          disabled: rateCard.rateCardIdentity.defaultCard,
          eventId: 'Delete',
          hasPrivilege: 'RATECARD__DELETE',
          hasPrivilegeEntity: rateCard,
        },
        { icon: 'content_copy', name: 'Duplicate', eventId: 'Duplicate', hasPrivilege: 'RATECARD__CREATE' },
      ]"
      [hasStatus]="rateCard.rateCardIdentity.trafficImported"
      [status]="'TRAFFICKED'"
      [hasIcon]="rateCard.rateCardIdentity.trafficImported"
      [statusIcon]="'swap_vert'"
      [statusIconClass]="'trafficked'"
      [hasSubtitle]="isParentCard(rateCard, loggedInUser.company) || rateCard.rateCardIdentity.costPlus"
      [subTitle]="isParentCard(rateCard, loggedInUser.company) ? 'Inherited from parent' : 'Cost Plus'"
      [hasButtons]="true"
      [cardTitle]="rateCard.name"
      (buttonClicked)="
        $event === 'Delete' ? showDeleteRateCardModal(rateCard) : showDuplicateRateCardModal(rateCard)
      " />
  </div>
</ng-container>

<!-- List View -->
<ng-container *ngIf="viewMode === RateCardViewMode.LIST">
  <div class="p-10">
    <scope-ui-table
      [loggedInUser]="loggedInUser"
      [unmappedData]="filteredRateCards"
      [displayedColumns]="rateCardsPreferenceColumns"
      [loading]="loadingRateCards"
      [noPagination]="true"
      [rowGaps]="true"
      [selectMode]="ScopeUiTableSelectMode.ROW"
      [menuOptions]="rateCardMenuOptions"
      [showToggleMenu]="true"
      [addToggleListColumn]="true"
      [noPreferences]="true"
      (onSelect)="onSelectRateCard($event.entity)"
      (onToggle)="onTogglePreference($event)" />
  </div>
</ng-container>

<scope-ui-paginator
  class="flex flex-col w-full justify-end mt-6"
  *ngIf="!loadingRateCards && totalCount > 0"
  [currentPage]="page"
  [totalCount]="totalCount"
  [pageSize]="pageSize"
  [sizeOptions]="pageSizeOptions"
  (changePage)="onChangePage($event)" />

<button
  *ngIf="archivedRateCards?.length > 0"
  class="text-link ml-10 pb-8"
  aria-label="View Archive"
  (click)="showArchive = !showArchive">
  {{ showArchive ? 'Hide' : 'View' }} Archive ({{ archivedRateCards ? archivedRateCards.length : 0 }})
  <mat-icon class="material-symbols-rounded orange">{{ showArchive ? 'expand_less' : 'expand_more' }}</mat-icon>
</button>

<div
  class="card-wrapper px-10 pt-2 pb-7"
  *ngIf="showArchive && viewMode === RateCardViewMode.TILES">
  <scope-ui-card-master
    *ngFor="let rateCard of archivedRateCards | orderBy: 'name' : 'asc' : false; trackBy: trackById"
    [actionButtons]="[
      {
        icon: rateCard.rateCardIdentity.defaultCard ? 'check_circle' : 'archive',
        name: rateCard.rateCardIdentity.defaultCard ? 'Default' : 'Unarchive',
        disabled: rateCard.rateCardIdentity.defaultCard,
        eventId: 'Unarchive',
        hasPrivilege: 'RATECARD__DELETE',
        hasPrivilegeEntity: rateCard,
      },
    ]"
    [hasStatus]="rateCard.rateCardIdentity.trafficImported"
    [status]="'TRAFFICKED'"
    [hasIcon]="rateCard.rateCardIdentity.trafficImported"
    [statusIcon]="'swap_vert'"
    [statusIconClass]="'trafficked'"
    [hasSubtitle]="isParentCard(rateCard, loggedInUser.company) || rateCard.rateCardIdentity.costPlus"
    [subTitle]="isParentCard(rateCard, loggedInUser.company) ? 'Inherited from parent' : 'Cost Plus'"
    [hasButtons]="true"
    [cardTitle]="rateCard.name"
    (buttonClicked)="$event === 'Unarchive' ? showUnarchiveRateCardModal(rateCard) : {}" />
</div>

<div
  class="px-10 pt-2 pb-7"
  *ngIf="showArchive && viewMode === RateCardViewMode.LIST">
  <scope-ui-table
    [loggedInUser]="loggedInUser"
    [unmappedData]="archivedRateCards"
    [displayedColumns]="rateCardsPreferenceColumns"
    [loading]="false"
    [noPagination]="true"
    [rowGaps]="true"
    [selectMode]="ScopeUiTableSelectMode.ROW"
    [menuOptions]="archivedRateCardMenuOptions"
    [showToggleMenu]="true"
    [addToggleListColumn]="true"
    [noPreferences]="true"
    (onSelect)="onSelectRateCard($event.entity)" />
</div>
